<template>
  <select
    v-model="internalValue"
    :name="name"
  >
    <option
      value=""
      selected=""
    >
      {{ defaultValue }}
    </option>
    <optgroup
      v-for="(item, idx) in items"
      v-if="item.values.length"
      :key="`${item.value}-${idx}`"
      :label="item.name"
    >
      <option
        v-for="(el, elIdx) in item.values"
        :key="elIdx"
        :value="el.value"
      >
        {{ el.name }}
      </option>
    </optgroup>
    <option 
      v-for="(item, idx) in items"
      v-if="item.values.length == 0"
      :key="`${item.value}-${idx}`"
      :value="item.value"
    >
      {{ item.name }}
    </option>
  </select>
</template>

<script>
// @group Partials
export default {
  name: 'FilterSelect',

  props: {
    // @vuese
    // Items for selecet
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    // @vuese
    // Default value
    defaultValue: {
      type: String,
      default: ''
    },
    // @vuese
    // Select name to make it unique
    name: {
      type: String,
      default: 'select',
    },
    // @vuese
    // v-model value from parent
    value: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      internalValue: this.value
    };
  },

  watch: {
    internalValue(newVal) {
      this.$emit('input', newVal);
    },
    // Watch for changes from parent v-model
    value(newVal) {
      this.internalValue = newVal;
    }
  }
};
</script>